import axios from 'axios';

axios.defaults.timeout = 100000;
axios.defaults.headers['Content-type'] = 'application/json';
